module.exports = __webpack_public_path__ + "static/media/amazingtrips.43e5b2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/amazingtrips.png
// module id = 87
// module chunks = 0